import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import BasicMenu from "./BasicMenu";
import TroubleshootOutlinedIcon from "@mui/icons-material/TroubleshootOutlined";
import LogoKarabalta from "../../assets/images/logo_png.PNG";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";
import { useGetDogovorsQuery } from "../../store/dogovorApi";
import { Link, useNavigate } from "react-router-dom";
import { dateForNotification } from "../../utilits/functionsForConstant";
import { logoutActionHandler } from "../../store/authSlice";
import { useDispatch } from "react-redux";
import ClickableChip from "./ClickableChip";
import { useSelector } from "react-redux";

const pages = ["Справочники", "Документы", "Отчеты", "Настройки"];
const subMenuPagesSpravochniki = [
  { name: "Контрагенты", link: "/contragenty" },
  { name: "Земли", link: "/nomenklatury" },
//  { name: "Объекты", link: "/nomenklatury2" },
  { name: "Категория", link: "/category" },
  { name: "Код платежа", link: "/paymentCode" },
  { name: "Kоэффициент-1", link: "/k1" },
  { name: "Kоэффициент-2", link: "/k2" },
  { name: "Kоэффициент-3", link: "/k3" },
  { name: "Kоэффициент-4", link: "/k4" },
  { name: "Kоэфф. инфляции", link: "/ki" },
  { name: "Kоэфф. зональности", link: "/kz" },
];
const subMenuPagesDocumenty = [
  { name: "Расчет", link: "/raschet" },
  { name: "Договор", link: "/dogovor" },
  { name: "Платежи", link: "/payment" },
];
const subMenuPagesOtchety = [
  { name: "Отчет по контрагенту", link: "/otchetPoContragentu" },
  { name: "Отчет по объектам", link: "/otchetPoObjectam" },
  { name: "Отчет по арендаторам", link: "/osv" },
  { name: "Отчет по налогам", link: "/otchetPoNalogam" },
  { name: "Сроки договора", link: "/sroki" },
];
const subMenuPagesNastroiki = [{ name: "Организация", link: "/organization" }];

function ResponsiveAppBar() {
  const { username } = useSelector((state) => state.auth);
  const { data: dogovorsFB } = useGetDogovorsQuery();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [dogovors, setDogovors] = React.useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    const setDataToStates = async () => {
      try {
        const dogovors = await dogovorsFB.data;
        setDogovors(dogovors);
      } catch (error) {}
    };
    setDataToStates();
  }, [dogovorsFB]);

  const experiationDateDogovors = dogovors.filter(
    (item) =>
      new Date(item.attributes.dateDogovorTo) < dateForNotification() &&
      new Date(item.attributes.dateDogovorTo) > new Date()
  );

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar position="static" style={{ backgroundColor: "green" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <img
            src={LogoKarabalta}
            alt="LOGO KARABALTA"
            style={{ width: "50px", height: "60px", marginRight: "8px" }}
          />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            АИС-АРЕНДА
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <TroubleshootOutlinedIcon
            sx={{ display: { xs: "flex", md: "none" }, mr: 1 }}
          />
          <Typography
            variant="h5"
            noWrap
            component="a"
            href=""
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            АИС-АРЕНДА
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            <BasicMenu
              onClick={handleCloseNavMenu}
              sx={{ my: 2, color: "white", display: "block" }}
              buttonName={"Cправочники"}
              subMenuList={subMenuPagesSpravochniki}
            ></BasicMenu>
            <BasicMenu
              onClick={handleCloseNavMenu}
              sx={{ my: 2, color: "white", display: "block" }}
              buttonName={"Документы"}
              subMenuList={subMenuPagesDocumenty}
            ></BasicMenu>
            <BasicMenu
              onClick={handleCloseNavMenu}
              sx={{ my: 2, color: "white", display: "block" }}
              buttonName={"Отчеты"}
              subMenuList={subMenuPagesOtchety}
            ></BasicMenu>
            <BasicMenu
              onClick={handleCloseNavMenu}
              sx={{ my: 2, color: "white", display: "block" }}
              buttonName={"Настройки"}
              subMenuList={subMenuPagesNastroiki}
            ></BasicMenu>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <IconButton
              size="large"
              aria-label="show new notifications"
              color="inherit"
              component={Link}
              to="/sroki"
            >
              <Badge
                badgeContent={experiationDateDogovors.length}
                color="error"
              >
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <Tooltip title="Открыть меню">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <ClickableChip
                  label={username}
                  variant="filled"
                  color="warning"
                  cursor='pointer'
                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem onClick={handleCloseUserMenu}>
                <Typography textAlign="center">Профиль</Typography>
              </MenuItem>
              <MenuItem
                onClick={() => logoutActionHandler({ dispatch, navigate })}
              >
                <Typography textAlign="center">Выход</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
